'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  function toggle(context) {
    if (!context.resolve.isTag(target, 'state', 'module')) {
      throw new Error('Cerebral operator.toggle: You have to use the STATE or MODULE tag as first argument');
    }

    var path = context.resolve.path(target);

    context[target.type].toggle(path);
  }

  toggle.displayName = 'operator.toggle(' + String(target) + ')';

  return toggle;
};
//# sourceMappingURL=toggle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/operators/toggle.js
// module id = 276
// module chunks = 0